/* eslint-disable array-callback-return, eqeqeq */
import React, { useState, useEffect } from "react";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";

import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import bellcurve from "highcharts/modules/histogram-bellcurve";

import { get_chart_options } from "../../options";
import { get_full_chart_options } from "../../options/full_chart_options";

import icon_info from "assets/images/icon-info.png";
import icon_chat from "assets/images/icon-chat.png";
import icon_chat_fill from "assets/images/icon-chat-fill.png";
import icon_expand from "assets/images/icon-expand.png";
import icon_collapse from "assets/images/icon-collapse.png";
import icon_search from "assets/images/icon-search.svg";
import icon_search_disabled from "assets/images/icon-search-disabled.svg";
import Select from "react-select";
import ReactTooltip from "react-tooltip";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";
import ls from "local-storage";
HighchartsMore(Highcharts);
bellcurve(Highcharts);

dayjs.extend(utc);
dayjs.extend(duration);

const Charts = (props) => {
  var {
    Highstock,
    fetching_annotations,
    selected_kpis,
    set_selected_kpis,
    analytics,
    recording_meta,
    set_annotate,
    set_annotate_range,
    annotations,
    zoom_type,
    kpi_names,
    get_mean,
    update_extremes,
    sorted_kpis,
    set_sorted_kpis,
    annotation_colours,
    show_system_annotations_flag,
    show_desaturations_flag,
    show_annotations_flag,
    show_artifects_flag,
    show_plotbands,
    showViewAnnotationPopup,
    customTimeRange,
    showEditAnnotationPopup,
    setCustomTimeRange,
    sorted_array_kpis,
    set_sorted_array_kpis,
    annotation_flags,
    set_annotation_flags,
    show_Custom_Annotation_Flag,
    set_show_Custom_Annotation_Flag,
    show_System_Annotation,
    set_show_System_Annotation,
    show_Desaturations,
    set_show_Desaturations,
    handle_artifects_flag,
    set_handle_artifects_flag,
    handle_annotations_sidebar_flag,
    set_handle_annotations_sidebar_flag,
    show_annotations_sidebar_flag,
    windowViewActive,
    setWindowViewActive,
    vital_parameters,
  } = props;
  const [graphExpanded, setGraphExpanded] = useState(true);

  const [windowViewKpi, setwindowViewKpi] = useState(null);
  const [zoomType, set_zoom_type] = useState(zoom_type);

  const tooltip_text = {
    SLP_STGS:
      "Sleep Stages of the subject detected by Sleepiz algorithm where 0 represents Deep Sleep and 1 represents Light Sleep and 2 represents Rapid Eye Movement and 3 represents Awake.",
    Y_DIST:
      "The displacement of the chest wall of a subject detected by the radar signal using Sleepiz algorithm.",
    MOV:
      "Detection of toss and turn of a subject detected by the radar signal and Sleepiz algorithm where 0 represents no movement and 1 represents movement (toss and turn).",
    BR: "Breathing rate of a subject estimated by the radar signal.",
    BRV: "Breathing Rate Variability.",
    HR:
      "Heart Rate Radar calculated from radar signal using Sleepiz algorithm.",
    HRV:
      "Heart Rate Variability is the standard deviation of the interbeat interval of the heartbeats within a 100 seconds window. The Sleepiz One computes this parameter by computing the standard deviation of the difference in peak interval of heartbeats every 100 seconds.",
    SPO2:
      "Blood oxygen saturation measured by the SPO2 sensor connected to the Sleepiz device",
    PR: "Pulse Rate measured by SPO2 sensor connected to the Sleepiz Device",
    I: "In phase raw signal recorded by the Sleepiz device.",
    Q: "Out phase raw signal recorded by the Sleepiz device.",
    IQ: "In and Out phase raw signal recorded by the Sleepiz device.",
    SA:
      "Sleep and Awake stages of the subject calculated by Sleepiz algorithm where 0 represents sleep stage and 1 represents awake stage.",
    TB:
      "Presence of a subject in front of Sleepiz device detected by Sleepiz algorithm where 1 represents the presence of a subject and 0 represents absence.",
    bp: "Blood pressure of a patient",
    blood_sugar: "Blood sugar of a patient",
    body_temp: "Body Temperature of a patient",
    NC_PSG:
      "Nasal Cannula PSG is the reference data which is collected from PSG.",
    THRX_PSG: "Thorax PSG is the reference data which is collected from PSG.",
    ABD_PSG: "Abdomen PSG is the reference data which is collected from PSG.",
    SPO2_PSG: "SPO2 PSG is the reference data which is collected from PSG.",
  };

  useEffect(
    () => {
      onSliderRangeSelection({ type: "all" });
    },
    [zoomType]
  );

  const configure_charts = () => {
    ["mousemove", "touchmove", "touchstart"].forEach(function(eventType) {
      const charts = document.getElementById("charts");

      if (charts) {
        charts.addEventListener(eventType, function(e) {
          let point, i, event;

          for (i = 0; i < Highstock.charts.length; i = i + 1) {
            let chart = Highstock.charts[i];

            if (chart && chart.pointer) {
              // Find coordinates within the chart
              event = chart.pointer.normalize(e);
              // Get the hovered point
              point = chart.series[0].searchPoint(event, true);

              if (point && point.highlight) {
                point.highlight(e);
              }
            }
          }
        });
      }
    });
  };

  useEffect(configure_charts, []);

  const sliderChangeHandler = () => {
    setTimeout(() => {
      setCustomTimeRange([max, min]);
    }, 10);
  };
  useEffect(() => {
    const charts = document.getElementById("time-range-slider");
    if (charts) {
      charts.addEventListener("mouseup", sliderChangeHandler);
      return () => {
        charts.removeEventListener("mouseup", sliderChangeHandler);
      };
    }
  }, []);
  const keyboardNavigation = (e) => {
    if (e.keyCode == 37) {
      navigateGraphToLeft();
    } else if (e.keyCode == 39) {
      navigateGraphToRight();
    }
  };
  useEffect(() => {
    const charts = document.getElementById("time-range-slider");
    if (charts) {
      charts.addEventListener(
        "keydown",
        sliderDebounce(keyboardNavigation, 500)
      );
      return () => charts.removeEventListener("keydown", sliderDebounce);
    }
  }, []);

  var max = "";
  var min = "";
  var initialMax = undefined;
  var initialMin = undefined;
  var lastMax = undefined;
  var lastMin = undefined;
  async function syncExtremes(e) {
    if (!(ls.get("initialMin") && ls.get("initialMax"))) {
      if (e.min !== undefined && e.max !== undefined) {
        await ls.set("initialMin", e.min);
        await ls.set("initialMax", e.max);
      }
    }

    if (!e.userMax) {
      // await ls.set("updatedMin", e.min);
      // await ls.set("updatedMax", e.max);
      if (e.min !== undefined && e.max !== undefined) {
        await ls.set("zoomMin", e.min);
        await ls.set("zoomMax", e.max);
      }
    }
    if (!(ls.get("zoomMin") && ls.get("zoomMax"))) {
      if (e.min !== undefined && e.max !== undefined) {
        await ls.set("zoomMin", e.min);
        await ls.set("zoomMax", e.max);
        initialMin = e.min;
        initialMax = e.max;
      }
    } else {
      if (
        show_annotations_flag == show_Custom_Annotation_Flag &&
        show_system_annotations_flag == show_System_Annotation &&
        show_desaturations_flag == show_Desaturations &&
        show_artifects_flag == handle_artifects_flag &&
        show_annotations_sidebar_flag == handle_annotations_sidebar_flag
      ) {
        if (e.min !== undefined && e.max !== undefined) {
          await ls.set("zoomMin", e.min);
          await ls.set("zoomMax", e.max);
          initialMin = e.min;
          initialMax = e.max;
        } else {
          initialMin = await ls.get("zoomMin"); //, e.min
          initialMax = await ls.get("zoomMax"); //, e.max
        }
      } else {
        initialMin = await ls.get("zoomMin"); //, e.min
        initialMax = await ls.get("zoomMax"); //, e.max
        setTimeout(() => {
          set_show_Custom_Annotation_Flag(show_annotations_flag);
          set_show_System_Annotation(show_system_annotations_flag);
          set_show_Desaturations(show_desaturations_flag);
          set_handle_artifects_flag(show_artifects_flag);
          set_handle_annotations_sidebar_flag(show_annotations_sidebar_flag);
        }, 250);
      }
    }

    if (e.trigger !== "syncExtremes") {
      // Prevent feedback loop
      Highstock.each(Highstock.charts, function(chart) {
        let isKpiChart = true; //full_chart and histogram in window view
        if (
          chart &&
          chart.renderTo.id &&
          (chart.renderTo.id.slice(0, 14) === "full-chart-kpi" ||
            chart.renderTo.id.slice(0, 12) === "wv-histogram")
        ) {
          isKpiChart = false;
          if (chart.renderTo.id.slice(0, 12) === "wv-histogram") {
            // Calculating selected duration data
            const durationStart = Math.round(e.min / 1000);
            const durationEnd = Math.round(e.max / 1000);
            if (durationStart !== durationEnd && analytics && windowViewKpi) {
              const startIndex = analytics[windowViewKpi]["ts"].findIndex(
                (t) => t >= durationStart
              );
              const endIndex = analytics[windowViewKpi]["ts"].findIndex(
                (t) => t >= durationEnd
              );
              const selectedData = analytics[windowViewKpi]["dataset"].slice(
                startIndex,
                endIndex
              );
              const filteredData = selectedData.filter(function(value) {
                return value !== null; //removing null values
              });
              const roundedData = filteredData.map((x) =>
                parseFloat(x.toFixed(1))
              );
              chart.series[1].setData(roundedData);
            }
          }
        }

        if (chart && isKpiChart) {
          // isKpichart means not Full Chart or distribution chart in Window View
          update_extremes({
            from: e.min || initialMin,
            to: e.max || initialMax,
          });
          max = e.max || initialMax;
          min = e.min || initialMin;
          if (chart && chart.xAxis && chart.xAxis[0].setExtremes) {
            // It is null while updating
            chart.xAxis[0].setExtremes(
              e.min || initialMin,
              e.max || initialMax,
              undefined,
              false,
              { trigger: "syncExtremes" }
            );
            const minRange = dayjs(e.min || initialMin || chart.xAxis[0].min);
            const maxRange = dayjs(e.max || initialMax || chart.xAxis[0].max);
            const diffTime = dayjs.duration(maxRange.diff(minRange));
            let timeDisplay = document.getElementById("time-range-difference");
            let hours;
            if (diffTime.days()) {
              hours = 24;
            } else {
              hours = diffTime.hours();
            }
            timeDisplay.innerHTML =
              hours +
              "hr " +
              diffTime.minutes() +
              "min " +
              diffTime.seconds() +
              "sec";
          }
        }
        if (
          windowViewActive &&
          chart &&
          chart.renderTo.id &&
          chart.renderTo.id.slice(0, 14) === "full-chart-kpi"
        ) {
          if (chart.xAxis) {
            //This is for highlighting the full-chart in window view when selection is made on other charts.
            chart.xAxis[0].removePlotBand("wv-full-chart-plot-band");
            chart.xAxis[0].addPlotBand({
              from: e.min,
              to: e.max,
              id: "wv-full-chart-plot-band",
              color: "#deefff",
            });
          }
        }
      });
    }
  }

  function toggleGraphAnnotation(kpi_id, e = null) {
    if (e !== null) {
      if (e.currentTarget.classList.contains("active-annotation")) {
        e.currentTarget.classList.remove("active-annotation");
      } else {
        set_zoom_type("x");
        e.currentTarget.classList.add("active-annotation");
      }
    } else {
      let collapseIcon = document.getElementsByClassName(
        `annotation_flags_${kpi_id}`
      )[0];
      let expandIcon = document.getElementsByClassName(
        `annotation_flags_${kpi_id}`
      )[1];
      if (
        !collapseIcon.classList.contains("active-annotation") &&
        !expandIcon.classList.contains("active-annotation")
      ) {
        collapseIcon.classList.add("active-annotation");
        expandIcon.classList.add("active-annotation");
      }
    }

    Highstock.charts.map((c) => {
      if (c && c.renderTo.id === "chart-kpi-" + kpi_id) {
        const flags = annotation_flags;
        if (flags[kpi_id]) {
          flags[kpi_id] = false;
        } else {
          flags[kpi_id] = true;
        }

        set_annotation_flags(flags);
      }
    });
  }

  function expandChart() {
    setGraphExpanded(true);
  }

  function collapseChart() {
    setGraphExpanded(false);
  }

  function toggleWindowView(e) {
    if (e.currentTarget.getAttribute("data-chartid")) {
      const kpi_id = e.currentTarget.getAttribute("data-chartid").slice(6); //to remove "chart-" from the chartid data attribute
      setwindowViewKpi(kpi_id);
      const new_selected_kpis = { ...selected_kpis };
      Object.keys(selected_kpis).forEach((kpi) => {
        if (kpi !== kpi_id) {
          //disabling every kpi other than the selected one
          if (selected_kpis[kpi]) {
            delete new_selected_kpis[kpi];
          }
        }
      });
      set_selected_kpis(new_selected_kpis);
    }
    setWindowViewActive(!windowViewActive);
  }

  const getWVGraphs = () => {
    let kpi_id = windowViewKpi;
    let noData = false;
    if (
      analytics[kpi_id] &&
      analytics[kpi_id].ts &&
      analytics[kpi_id].ts.length === 0
    ) {
      noData = true;
    }
    const kpiData = analytics[kpi_id]["dataset"];
    const filteredData = kpiData.filter(function(value) {
      return value !== null; //removing null values
    });
    const roundedData = filteredData.map((x) => parseFloat(x.toFixed(1)));
    let moderateMin,
      moderateMax,
      severeMin,
      severeMax,
      moderateMinF,
      moderateMaxF,
      moderateMinS,
      moderateMaxS,
      severeMinF,
      severeMaxF,
      severeMinS,
      severeMaxS;
    if (windowViewKpi === "BR" && vital_parameters !== undefined) {
      moderateMinF = Number(vital_parameters.br.modFromF);
      moderateMaxF = Number(vital_parameters.br.modToF);
      moderateMinS = Number(vital_parameters.br.modFromS);
      moderateMaxS = Number(vital_parameters.br.modToS);
      severeMinF = Number(vital_parameters.br.sevFromF);
      severeMaxF = Number(vital_parameters.br.sevToF);
      severeMinS = Number(vital_parameters.br.sevFromS);
      severeMaxS = Number(vital_parameters.br.sevToS);
    } else if (windowViewKpi === "PR" && vital_parameters !== undefined) {
      moderateMinF = Number(vital_parameters.pr.modFromF);
      moderateMaxF = Number(vital_parameters.pr.modToF);
      moderateMinS = Number(vital_parameters.pr.modFromS);
      moderateMaxS = Number(vital_parameters.pr.modToS);
      severeMinF = Number(vital_parameters.pr.sevFromF);
      severeMaxF = Number(vital_parameters.pr.sevToF);
      severeMinS = Number(vital_parameters.pr.sevFromS);
      severeMaxS = Number(vital_parameters.pr.sevToS);
    } else if (windowViewKpi === "SPO2" && vital_parameters !== undefined) {
      moderateMin = Number(vital_parameters.spo2.modFrom);
      moderateMax = Number(vital_parameters.spo2.modTo);
      severeMin = Number(vital_parameters.spo2.sevFrom);
      severeMax = Number(vital_parameters.spo2.sevTo);
    }

    const options = {
      title: {
        text: null,
      },
      legend: {
        enabled: false,
      },
      yAxis: [
        {
          visible: true,
          title: {
            text: null,
          },
        },
      ],
      xAxis: {
        showLastLabel: true,
        plotBands: [
          {
            from: moderateMin ? moderateMin : moderateMinF,
            to: moderateMax ? moderateMax : moderateMaxF,
            color: show_plotbands ? "#fcffbd" : "white",
            label: {
              text: "",
            },
          },
          {
            from: severeMin ? severeMin : severeMinF,
            to: severeMax ? severeMax : severeMaxF,
            color: show_plotbands ? "#ffbdbd" : "white",
            label: {
              text: "",
            },
          },
          {
            from: moderateMinS ? moderateMinS : "",
            to: moderateMaxS ? moderateMaxS : "",
            color: show_plotbands ? "#fcffbd" : "white",
            label: {
              text: "",
            },
          },
          {
            from: severeMinS ? severeMinS : "",
            to: severeMaxS ? severeMaxS : "",
            color: show_plotbands ? "#ffbdbd" : "white",
            label: {
              text: "",
            },
          },
        ],
      },
      credits: false,
      series: [
        {
          name: "Frequency",
          type: "histogram",
          baseSeries: 1,
          animation: false,
        },
        {
          name: "Data",
          type: "scatter",
          data: roundedData,
          visible: false,
          marker: {
            radius: 1.5,
          },
        },
      ],
    };

    return (
      <div className="charts-wrap window-view-active">
        <div className="chart-block expanded window-view-active">
          <div className="chart-details expanded-chart-details">
            <div className="chart-details-left">
              <DragHandle />
              <span className="graph-title">{kpi_names[kpi_id]}</span>
              <span
                className="icon info-icon"
                data-tip
                data-for={`'tooltip-${kpi_id}'`}
              >
                <img src={icon_info} alt="Icon" />
              </span>
            </div>
            <div className="chart-details-right">
              <span
                title="Window View"
                data-chartid={`chart-${kpi_id}`}
                className="icon window-view-icon"
                onClick={(e) => toggleWindowView(e)}
              >
                {windowViewActive ? (
                  <img src={icon_search} alt="Icon" />
                ) : (
                  <img src={icon_search_disabled} alt="Icon" />
                )}
              </span>
            </div>
          </div>
          {!noData && (
            <HighchartsReact
              kpi_name={kpi_names[kpi_id]}
              allowChartUpdate={true}
              key={kpi_id}
              highcharts={Highstock}
              constructorType="chart"
              containerProps={{
                className: "chart-container-wrap window-view-active",
                id: "wv-histogram" + kpi_id,
              }}
              options={options}
            />
          )}
          <div className="chart-details collapse-chart-details">
            <div className="chart-details-right">
              <span
                className="icon info-icon"
                data-tip
                data-for={`'tooltip-${kpi_id}'`}
              >
                <img src={icon_info} alt="Icon" />
              </span>
              <span
                title="Window View"
                data-chartid={`chart-${kpi_id}`}
                className="icon window-view-icon"
                onClick={(e) => toggleWindowView(e)}
              >
                {windowViewActive ? (
                  <img src={icon_search} alt="Icon" />
                ) : (
                  <img src={icon_search_disabled} alt="Icon" />
                )}
              </span>
            </div>
          </div>
          <ReactTooltip
            id={`'tooltip-${kpi_id}'`}
            className="graph-tooltip"
            place="bottom"
          >
            {tooltip_text[kpi_id]}
          </ReactTooltip>
        </div>
      </div>
    );
  };

  useEffect(
    () => {
      const histogramChart = Highstock.charts.filter(
        (chart) =>
          chart &&
          chart.renderTo.id &&
          chart.renderTo.id.slice(0, 12) === "wv-histogram"
      );
      if (histogramChart && histogramChart[0] && histogramChart[0].reflow) {
        histogramChart[0].reflow();
      }
    },
    [windowViewActive]
  );

  const getFullNightChart = (selected_zoom_type) => {
    //For Window View
    let kpi_id = windowViewKpi;
    let noData = false;
    if (
      analytics[kpi_id] &&
      analytics[kpi_id].ts &&
      analytics[kpi_id].ts.length === 0
    ) {
      noData = true;
    }

    return (
      <div className="charts-wrap window-view-active">
        <div className="chart-block expanded window-view-active">
          <div className="chart-details expanded-chart-details">
            <div className="chart-details-left">
              <DragHandle />
              <span className="graph-title">{kpi_names[kpi_id]}</span>
              <span
                className="icon info-icon"
                data-tip
                data-for={`'tooltip-${kpi_id}'`}
              >
                <img src={icon_info} alt="Icon" />
              </span>
            </div>
            <div className="chart-details-right">
              <span
                title="Window View"
                data-chartid={`chart-${kpi_id}`}
                className="icon window-view-icon"
                onClick={(e) => toggleWindowView(e)}
              >
                {windowViewActive ? (
                  <img src={icon_search} alt="Icon" />
                ) : (
                  <img src={icon_search_disabled} alt="Icon" />
                )}
              </span>
            </div>
          </div>
          {!noData && (
            <HighchartsReact
              kpi_name={kpi_names[kpi_id]}
              allowChartUpdate={true}
              key={kpi_id}
              highcharts={Highstock}
              constructorType="stockChart"
              containerProps={{
                className: "chart-container-wrap window-view-active",
                id: "full-chart-kpi-" + kpi_id,
              }}
              options={get_full_chart_options({
                kpi_id,
                syncExtremes,
                analytics: analytics[kpi_id],
                sqbAnalytics: analytics["SQB"] ? analytics["SQB"] : null,
                get_mean,
                zoom_type: selected_zoom_type,
                customTimeRange,
                setCustomTimeRange,
                show_artifects_flag,
              })}
            />
          )}
          <div className="chart-details collapse-chart-details">
            <div className="chart-details-right">
              <span
                className="icon info-icon"
                data-tip
                data-for={`'tooltip-${kpi_id}'`}
              >
                <img src={icon_info} alt="Icon" />
              </span>
              <span
                title="Window View"
                data-chartid={`chart-${kpi_id}`}
                className="icon window-view-icon"
                onClick={(e) => toggleWindowView(e)}
              >
                {windowViewActive ? (
                  <img src={icon_search} alt="Icon" />
                ) : (
                  <img src={icon_search_disabled} alt="Icon" />
                )}
              </span>
            </div>
          </div>
          <ReactTooltip
            id={`'tooltip-${kpi_id}'`}
            className="graph-tooltip"
            place="bottom"
          >
            {tooltip_text[kpi_id]}
          </ReactTooltip>
        </div>
      </div>
    );
  };

  const get_charts = (recording_data_meta) => {
    const charts_elements = sorted_kpis.map((kpi_id, index) => {
      if (!Object.keys(selected_kpis).find((k) => k === kpi_id)) {
        return null;
      }

      if (selected_kpis && selected_kpis[kpi_id] && analytics[kpi_id]) {
        let mixed_annotations = [];
        if (annotations && annotations.length > 0) {
          if (show_annotations_flag) {
            annotations.forEach((a) => {
              if (
                a.type === "custom" &&
                Object.keys(a.kpiList).indexOf(kpi_id) > -1
              ) {
                mixed_annotations.push(a);
              }
            });
          }

          if (show_system_annotations_flag) {
            annotations.forEach((a) => {
              if (
                (a.type === "system" || a.type === "system-edit") &&
                Object.keys(a.kpiList).indexOf(kpi_id) > -1
              ) {
                mixed_annotations.push(a);
              }
            });
          }

          if (show_desaturations_flag) {
            annotations.forEach((a) => {
              if (
                a.type === "desaturation" &&
                Object.keys(a.kpiList).indexOf(kpi_id) > -1
              ) {
                mixed_annotations.push(a);
              }
            });
          }
        }

        let expandedClass = "";
        if (graphExpanded) {
          expandedClass = "expanded";
        }

        return (
          <SortableItem
            key={`item-${kpi_id}`}
            index={index}
            kpi_id={kpi_id}
            expandedClass={expandedClass}
            mixed_annotations={mixed_annotations}
            recording_data_meta={recording_data_meta}
          />
        );
      }

      return null;
    });

    return charts_elements;
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (selected_kpis && Object.keys(selected_kpis).length > 1) {
      set_sorted_kpis(arrayMove(sorted_kpis, oldIndex, newIndex));

      let sorted_array_kpis_keys = Object.keys(sorted_array_kpis);
      let sorted_array_kpis_values = Object.values(sorted_array_kpis);
      sorted_array_kpis_keys = arrayMove(
        sorted_array_kpis_keys,
        oldIndex,
        newIndex
      );
      sorted_array_kpis_values = arrayMove(
        sorted_array_kpis_values,
        oldIndex,
        newIndex
      );
      let final_sorted_array_kpis = mergeArrToJSON(
        sorted_array_kpis_keys,
        sorted_array_kpis_values
      );

      set_sorted_array_kpis(final_sorted_array_kpis);
    }
  };

  const mergeArrToJSON = (array1, array2) =>
    array1
      .map((item, i) => ({ [item]: array2[i] }))
      .reduce((json, val) => Object.assign({}, json, val));

  const SortableContainer = sortableContainer(({ children }) => (
    <ul
      className={
        "charts-wrap " + (windowViewActive ? "window-view-active" : "")
      }
      id="charts"
    >
      {children}
    </ul>
  ));

  const DragHandle = sortableHandle(() => (
    <span data-tip data-for="tooltip-drag" className="icon drag-icon">
      ::
    </span>
  ));

  const SortableItem = sortableElement(
    ({ kpi_id, expandedClass, mixed_annotations, recording_data_meta }) => {
      let noData = false;
      if (
        analytics[kpi_id] &&
        analytics[kpi_id].ts &&
        analytics[kpi_id].ts.length === 0
      ) {
        noData = true;
      }

      // console.log()

      const data = () => {
        let dataChart;
        dataChart = get_chart_options({
          kpi_id,
          syncExtremes,
          recording_meta: recording_data_meta,
          custom_chart_type: true,
          analytics: analytics[kpi_id],
          sqbAnalytics: analytics["SQB"] ? analytics["SQB"] : null,
          get_mean,
          zoom_type: zoomType,
          set_annotate,
          set_annotate_range,
          mixed_annotations: mixed_annotations,
          annotation_flags,
          toggleGraphAnnotation,
          annotation_colours,
          showViewAnnotationPopup,
          customTimeRange,
          showEditAnnotationPopup,
          setCustomTimeRange,
          show_artifects_flag,
          show_plotbands,
          vital_parameters,
          lastMax,
          lastMin,
        });
        return dataChart;
      };

      return (
        <li
          key={"chart-div-block-" + kpi_id}
          className={
            "chart-block " +
            expandedClass +
            (windowViewActive ? " window-view-active" : "")
          }
          id={`chart-${kpi_id}`}
        >
          <div className="chart-details expanded-chart-details">
            <div className="chart-details-left">
              <DragHandle />
              <ReactTooltip
                id="tooltip-drag"
                className="graph-tooltip"
                place="bottom"
              >
                Drag this graph to readjust the order of the channels.
              </ReactTooltip>
              <span className="graph-title">{kpi_names[kpi_id]}</span>
              <span
                className="icon info-icon"
                data-tip
                data-for={`'tooltip-${kpi_id}'`}
              >
                <img src={icon_info} alt="Icon" />
              </span>
            </div>
            <div className="chart-details-right">
              {!noData && (
                <span
                  title="Annotation"
                  className={
                    "icon annotation_flags_" +
                    kpi_id +
                    " " +
                    (annotation_flags[kpi_id] ? "active-annotation" : "")
                  }
                  onClick={(e) => toggleGraphAnnotation(kpi_id, e)}
                >
                  <img className="icon-chat" src={icon_chat} alt="Icon" />
                  <img
                    className="icon-chat-fill"
                    src={icon_chat_fill}
                    alt="Icon"
                  />
                </span>
              )}
              <span
                title="Expand"
                data-chartid={`chart-${kpi_id}`}
                className="icon expand-icon"
                onClick={expandChart}
              >
                <img src={icon_expand} alt="Icon" />
              </span>
              <span
                title="Collapse"
                data-chartid={`chart-${kpi_id}`}
                className="icon collapse-icon"
                onClick={collapseChart}
              >
                <img src={icon_collapse} alt="Icon" />
              </span>
              <span
                title="Window View"
                data-chartid={`chart-${kpi_id}`}
                className="icon window-view-icon"
                onClick={(e) => toggleWindowView(e)}
              >
                {windowViewActive ? (
                  <img src={icon_search} alt="Icon" />
                ) : (
                  <img src={icon_search_disabled} alt="Icon" />
                )}
              </span>
              <span
                title={zoomType === "xy" ? "X-axis Zoom" : "XY-axis Zoom"}
                className={"Y-Zoom"}
              >
                {zoomType === "xy" && (
                  <button
                    className="button"
                    onClick={() => {
                      set_zoom_type("x");
                    }}
                  >
                    {" "}
                    X
                  </button>
                )}
                {zoomType === "x" && (
                  <button
                    className="button"
                    onClick={() => {
                      if (!annotation_flags[kpi_id]) {
                        set_zoom_type("xy");
                      }
                    }}
                  >
                    {" "}
                    XY
                  </button>
                )}
              </span>
            </div>
          </div>
          {noData && (
            <div className="no-data-kpi-block">
              <span className="no-data-kpi-block-content">
                No data available for {kpi_names[kpi_id]}.
              </span>
            </div>
          )}

          {!noData && (
            <HighchartsReact
              kpi_name={kpi_names[kpi_id]}
              allowChartUpdate={true}
              key={kpi_id}
              highcharts={Highstock}
              constructorType={
                kpi_names[kpi_id] === "Sleep Stages" ? "chart" : "stockChart"
              }
              containerProps={{
                className: `chart-container-wrap ${
                  windowViewActive ? " window-view-active" : ""
                }`,
                id: "chart-kpi-" + kpi_id,
              }}
              options={
                data()
                // get_chart_options({
                //     kpi_id,
                //     syncExtremes,
                //     custom_chart_type: true,
                //     analytics: analytics[kpi_id],
                //     sqbAnalytics: analytics['SQB'] ? analytics['SQB'] : null,
                //     get_mean,
                //     zoom_type: zoomType,
                //     set_annotate,
                //     set_annotate_range,
                //     mixed_annotations: mixed_annotations,
                //     annotation_flags,
                //     toggleGraphAnnotation,
                //     annotation_colours,
                //     showViewAnnotationPopup,
                //     customTimeRange,
                //     showEditAnnotationPopup,
                //     setCustomTimeRange,
                //     show_artifects_flag,
                //     show_plotbands,
                //     vital_parameters,
                // })
              }
            />
          )}
          <div className="chart-details collapse-chart-details">
            <div className="chart-details-right">
              <span
                className="icon info-icon"
                data-tip
                data-for={`'tooltip-${kpi_id}'`}
              >
                <img src={icon_info} alt="Icon" />
              </span>
              {!noData && (
                <span
                  title="Annotation"
                  className={
                    "icon annotation_flags_" +
                    kpi_id +
                    " " +
                    (annotation_flags[kpi_id] ? "active-annotation" : "")
                  }
                  onClick={(e) => toggleGraphAnnotation(kpi_id, e)}
                >
                  <img className="icon-chat" src={icon_chat} alt="Icon" />
                  <img
                    className="icon-chat-fill"
                    src={icon_chat_fill}
                    alt="Icon"
                  />
                </span>
              )}
              <span
                data-chartid={`chart-${kpi_id}`}
                className="icon expand-icon"
                onClick={expandChart}
              >
                <img src={icon_expand} alt="Icon" />
              </span>
              <span
                title="Collapse"
                data-chartid={`chart-${kpi_id}`}
                className="icon collapse-icon"
                onClick={collapseChart}
              >
                <img src={icon_collapse} alt="Icon" />
              </span>
              {kpi_id !== "bp" &&
                kpi_id !== "blood_sugar" &&
                kpi_id !== "body_temp" && (
                  <span
                    title="Window View"
                    data-chartid={`chart-${kpi_id}`}
                    className="icon window-view-icon"
                    onClick={(e) => toggleWindowView(e)}
                  >
                    {windowViewActive ? (
                      <img src={icon_search} alt="Icon" />
                    ) : (
                      <img src={icon_search_disabled} alt="Icon" />
                    )}
                  </span>
                )}
              <span
                title={zoomType === "xy" ? "X-axis Zoom" : "XY-axis Zoom"}
                className={"Y-Zoom"}
              >
                {zoomType === "xy" && (
                  <button
                    className="button"
                    onClick={() => {
                      set_zoom_type("x");
                      console.log("clicked");
                    }}
                  >
                    {" "}
                    X
                  </button>
                )}
                {zoomType === "x" && (
                  <button
                    className="button"
                    onClick={() => {
                      set_zoom_type("xy");
                      console.log("clicked");
                    }}
                  >
                    {" "}
                    XY
                  </button>
                )}
              </span>
            </div>
          </div>
          <ReactTooltip
            id={`'tooltip-${kpi_id}'`}
            className="graph-tooltip"
            place="bottom"
          >
            {tooltip_text[kpi_id]}
          </ReactTooltip>
        </li>
      );
    }
  );

  const rangeOptions = [
    { type: "sec", value: "30", label: "30 Sec" },
    { type: "min", value: "1", label: "01 Min" },
    { type: "min", value: "3", label: "03 Min" },
    { type: "min", value: "5", label: "05 Min" },
    { type: "min", value: "8", label: "08 Min" },
    { type: "min", value: "10", label: "10 Min" },
    { type: "min", value: "20", label: "20 Min" },
    { type: "all", value: "all", label: "Full Night" },
  ];

  const sliderDebounce = (func, delay) => {
    let debounceTimer;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  let iteration = 0;
  const onSliderRangeSelection = async (option) => {
    let totalSeconds = 0;
    if (option.type === "sec") {
      totalSeconds = option.value * 1000;
    } else if (option.type === "min") {
      totalSeconds = option.value * 60 * 1000;
    }
    const charts = Highstock.charts.filter((chart) => {
      if (chart) {
        return true;
      } else {
        return false;
      }
    });
    let getGraphaxisValue = [];
    charts.map((chart) => {
      if (chart && chart.navigator) {
        initialMin = chart.navigator.chart.xAxis[0].min;
        initialMax = chart.navigator.chart.xAxis[0].max;
        ls.set("zoomMin", initialMin);
        ls.set("zoomMax", initialMax);
        if (totalSeconds === 0) {
          getGraphaxisValue = chart.xAxis.map((item) => {
            return {
              graphMin: item.dataMin,
              graphMax: item.dataMax,
            };
          });
          initialMin =
            totalSeconds === 0
              ? getGraphaxisValue[1]
                ? getGraphaxisValue[1].graphMin
                : getGraphaxisValue[1].graphMin
              : initialMin;
          initialMax =
            totalSeconds === 0
              ? getGraphaxisValue[1]
                ? getGraphaxisValue[1].graphMax
                : getGraphaxisValue[1].graphMax
              : initialMax;
          ls.set("zoomMin", initialMin);
          ls.set("zoomMax", initialMax);
          chart.zoomOut();
          const minRange = dayjs(chart.xAxis[0].min);
          const maxRange = dayjs(chart.xAxis[0].max);
          const diffTime = dayjs.duration(maxRange.diff(minRange));
          let timeDisplay = document.getElementById("time-range-difference");
          let hours;
          if (diffTime.days()) {
            hours = 24;
          } else {
            hours = diffTime.hours();
          }
          if (timeDisplay) {
            timeDisplay.innerHTML =
              hours +
              "hr " +
              diffTime.minutes() +
              "min " +
              diffTime.seconds() +
              "sec";
          }
          set_annotate_range([
            dayjs
              .utc(Math.round(chart.xAxis[0].min))
              .tz(recording_meta.timezone)
              .format("YYYY-MM-DD HH:mm:ss"),
            dayjs
              .utc(Math.round(chart.xAxis[0].max))
              .tz(recording_meta.timezone)
              .format("YYYY-MM-DD HH:mm:ss"),
          ]);
          iteration++;
          if (iteration < 2) {
            onSliderRangeSelection(option);
          }
        } else {
          let min = chart.navigator.chart.xAxis[0].min;
          let max = chart.navigator.chart.xAxis[0].min + totalSeconds;
          chart.xAxis[0].setExtremes(min, max);
          setCustomTimeRange([
            chart.navigator.chart.xAxis[0].max,
            chart.navigator.chart.xAxis[0].min,
          ]);
        }
        update_extremes({
          from: chart.navigator.chart.xAxis[0].min,
          to: chart.navigator.chart.xAxis[0].max,
        });
      }
    });
  };

  const navigateGraphToLeft = () => {
    const charts = Highstock.charts.filter(
      (c) => c && c.renderTo.id === "time-range-slider"
    );
    charts.map((chart) => {
      if (chart && chart.navigator) {
        const selectedRange =
          chart.navigator.chart.xAxis[0].max -
          chart.navigator.chart.xAxis[0].min;
        let overlap = selectedRange * 0.2;
        let min = chart.navigator.chart.xAxis[0].min - selectedRange + overlap;
        let max = chart.navigator.chart.xAxis[0].min + overlap;

        if (min <= chart.xAxis[1].min) {
          min = chart.xAxis[1].min;
        }

        if (max <= chart.xAxis[1].min) {
          max = chart.navigator.chart.xAxis[0].max;
        }
        chart.xAxis[0].setExtremes(min, max);
        setCustomTimeRange([max, min]);
      }
    });
  };

  const navigateGraphToRight = () => {
    const charts = Highstock.charts.filter(
      (c) => c && c.renderTo.id === "time-range-slider"
    );

    charts.map((chart) => {
      if (chart && chart.navigator) {
        const selectedRange =
          chart.navigator.chart.xAxis[0].max -
          chart.navigator.chart.xAxis[0].min;
        let overlap = selectedRange * 0.2;
        let min = chart.navigator.chart.xAxis[0].max - overlap;
        let max = chart.navigator.chart.xAxis[0].max + selectedRange - overlap;

        if (max >= chart.xAxis[1].max) {
          max = chart.xAxis[1].max;
        }

        if (min >= chart.xAxis[1].max) {
          min = chart.navigator.chart.xAxis[0].min;
        }

        chart.xAxis[0].setExtremes(min, max);
        setCustomTimeRange([max, min]);
      }
    });
  };

  const getTimeRangeSelector = (selected_zoom_type, recording_meta_data) => {
    if (
      selected_kpis &&
      Object.keys(selected_kpis).length > 0 &&
      analytics &&
      analytics[Object.keys(selected_kpis)[0]]
    ) {
      let totalData = 0;
      let kpi_slider;
      Object.keys(selected_kpis).map((k) => {
        if (
          k === "IQ" &&
          analytics &&
          analytics[k] &&
          Boolean(analytics[k].I || analytics[k].Q)
        ) {
          if (analytics[k].I.ts.length || analytics[k].Q.ts.length) {
            totalData += analytics[k].I.ts.length;
            totalData += analytics[k].Q.ts.length;
            kpi_slider = k;
          }
        } else if (
          analytics &&
          analytics[k] &&
          analytics[k].ts &&
          analytics[k].ts.length > 0
        ) {
          totalData += analytics[k].ts.length;
          kpi_slider = k;
        }
      });

      if (totalData === 0) {
        return "";
      }

      const kpi_id = kpi_slider;

      let diffTime;
      if (kpi_slider === "IQ") {
        const i_min = Number(analytics[kpi_id].I.ts[0]);
        const i_max = Number(
          analytics[kpi_id].I.ts[analytics[kpi_id].I.ts.length - 1]
        );
        const q_min = Number(analytics[kpi_id].Q.ts[0]);
        const q_max = Number(
          analytics[kpi_id].Q.ts[analytics[kpi_id].Q.ts.length - 1]
        );
        const min = i_min <= q_min ? "I" : "Q";
        const max = i_max >= q_max ? "I" : "Q";

        diffTime = dayjs.duration(
          dayjs
            .utc(
              analytics[kpi_id][max].ts[analytics[kpi_id][max].ts.length - 1]
            )
            .diff(dayjs.utc(analytics[kpi_id][min].ts[0]))
        );
      } else {
        diffTime = dayjs.duration(
          dayjs
            .utc(analytics[kpi_id].ts[analytics[kpi_id].ts.length - 1])
            .diff(dayjs.utc(analytics[kpi_id].ts[0]))
        );
      }
      let tickInterval = 3600 * 1000; // 1 hour
      if (diffTime < 3600 * 4) {
        // less than 4 hours
        tickInterval = Math.round(diffTime / 8) * 1000;
      }

      const options = {
        rangeSelector: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
        },
        yAxis: {
          height: 0,
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
        },
        xAxis: {
          lineWidth: 1,
          lineColor: "rgba(60, 60, 60, 0.3)",
          gridLineColor: "rgba(60, 60, 60, 0.3)",
          tickLength: 0,
          offset: 35,
          labels: {
            enabled: false,
            align: "center",
          },
        },
        navigator: {
          enabled: true,
          maskFill: "rgba(143, 189, 233, 0.25)",
          outlineColor: "#1E87D7",
          outlineWidth: 0,
          height: 44,
          adaptToUpdatedData: false,
          xAxis: {
            // startOnTick: true,
            // endOnTick: true,
            tickInterval: tickInterval,
            ordinal: false,
            labels: {
              align: "center",
              y: 11,
              style: {
                fontFamily: "Avenir",
              },
            },
          },
        },
        scrollbar: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
      };

      let dataset = get_chart_options({
        kpi_id,
        custom_chart_type: false,
        syncExtremes,
        recording_meta: recording_meta_data,
        analytics: analytics[kpi_id],
        // analytics: (kpi_id === "SPO2" || kpi_id === "PR") ? analytics["SQB"] : analytics[kpi_id],
        get_mean,
        zoom_type: selected_zoom_type,
        height: 60,
      });

      dataset.rangeSelector = {
        ...dataset.rangeSelector,
        ...options.rangeSelector,
      };
      dataset.tooltip = { ...dataset.tooltip, ...options.tooltip };
      dataset.yAxis = { ...dataset.yAxis, ...options.yAxis };
      dataset.xAxis = { ...dataset.xAxis, ...options.xAxis };
      dataset.navigator = { ...dataset.navigator, ...options.navigator };
      dataset.scrollbar = { ...dataset.scrollbar, ...options.scrollbar };

      setTimeout(() => {
        if (!(ls.get("zoomMin") && ls.get("zoomMax"))) {
          onSliderRangeSelection(rangeOptions[rangeOptions.length - 1]);
        }
      }, 1000);

      return (
        <div className="range-slider-wrap">
          <HighchartsReact
            allowChartUpdate={true}
            key={"time-range-navigator"}
            highcharts={Highstock}
            constructorType="stockChart"
            options={dataset}
            containerProps={{
              className: "range-slider-block",
              id: "time-range-slider",
              tabIndex: "1",
            }}
          />
          <div className="range-select-wrap">
            <span id="time-range-difference" className="time-difference" />
            <Select
              className="range-select custom-react-select"
              classNamePrefix="custom-react-select"
              defaultValue={rangeOptions[rangeOptions.length - 1]}
              isDisabled={false}
              isLoading={false}
              isClearable={false}
              isRtl={false}
              isSearchable={false}
              name="time-range"
              options={rangeOptions}
              menuPlacement="top"
              onChange={(opt) => {
                iteration = 0;
                onSliderRangeSelection(opt);
              }}
            />
            <div className="range-arrows">
              <span
                tabIndex="1"
                className="zmdi zmdi-chevron-left zmdi-hc-fw"
                onKeyDown={(e) => {
                  e.persist();
                  if (e.keyCode == 37) {
                    keyboardNavigation(e);
                  }
                }}
                onClick={navigateGraphToLeft}
              />
              <span
                tabIndex="1"
                className="zmdi zmdi-chevron-right zmdi-hc-fw"
                onKeyDown={(e) => {
                  e.persist();
                  if (e.keyCode == 39) {
                    keyboardNavigation(e);
                  }
                }}
                onClick={navigateGraphToRight}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      {/* WV = Window View*/}
      {windowViewActive && getWVGraphs()}
      <SortableContainer
        distance={10}
        lockToContainerEdges={true}
        onSortEnd={onSortEnd}
        useDragHandle={true}
      >
        {!fetching_annotations && recording_meta && get_charts(recording_meta)}
      </SortableContainer>
      {windowViewActive && getFullNightChart(zoom_type)}
      {recording_meta && getTimeRangeSelector(zoomType, recording_meta)}
    </>
  );
};

export default React.memo(Charts, (prevProps, nextProps) => {
  return (
    document.getElementById("charts") &&
    Object.values(nextProps.selected_kpis).length ==
      document.getElementById("charts").children.length &&
    prevProps.sorted_kpis == nextProps.sorted_kpis &&
    prevProps.show_system_annotations_flag ==
      nextProps.show_system_annotations_flag &&
    prevProps.show_desaturations_flag == nextProps.show_desaturations_flag &&
    prevProps.show_annotations_flag == nextProps.show_annotations_flag &&
    prevProps.show_artifects_flag == nextProps.show_artifects_flag &&
    prevProps.show_plotbands == nextProps.show_plotbands &&
    prevProps.show_annotations_sidebar_flag ==
      nextProps.show_annotations_sidebar_flag &&
    prevProps.annotations == nextProps.annotations &&
    prevProps.windowViewActive == nextProps.windowViewActive &&
    prevProps.wvHistogramData == nextProps.wvHistogramData &&
    JSON.stringify(prevProps.annotation_flags) ==
      JSON.stringify(nextProps.annotation_flags)
    // && prevProps.annotation_flags == nextProps.annotation_flags
  );
});

// export default Charts;
